import { useNavigate } from "react-router-dom";
import { useReveal } from "@/hooks/useReveal";

export const WarehouseSection = () => {
  const navigate = useNavigate();
  const [ref, shown] = useReveal({ threshold: 0.2 });

  return (
    <section id="warehouse" data-testid="section-warehouse" className="seam-top bg-calico">
      <div className="mx-auto max-w-[1200px] px-5 py-[120px] md:px-7 lg:px-10">
        <div
          ref={ref}
          className={`mx-auto max-w-2xl text-center transition-[opacity,transform] duration-[600ms] ease-out ${
            shown ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"
          }`}
        >
          <p className="eyebrow text-xs text-ember">Warehouse</p>
          <h2 className="font-display mt-5 text-3xl font-extrabold leading-[1.08] text-charcoal md:text-[40px]">
            View our warehouse.
          </h2>
          <p className="mx-auto mt-6 max-w-xl font-inter text-base leading-[1.65] text-charcoal/75">
            Take the full 360° tour of our warehouse: millions of yards of
            fabric, ready to purchase. Tap a video, then drag or move your phone
            to look around in every direction.
          </p>
          <button
            type="button"
            data-testid="warehouse-cta-button"
            onClick={() => navigate("/warehouse")}
            className="eyebrow mt-10 bg-charcoal px-8 py-4 text-[13px] text-calico transition-colors duration-300 ease-out hover:bg-ink hover:text-warmwhite focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-kraft"
          >
            View our warehouse
          </button>
        </div>
      </div>
    </section>
  );
};
